
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Mail, Send, ArrowUpDown } from "lucide-react";

interface EmailDirectionFilterProps {
  currentDirection: 'all' | 'incoming' | 'outgoing';
  onDirectionChange: (direction: 'all' | 'incoming' | 'outgoing') => void;
  incomingCount?: number;
  outgoingCount?: number;
  totalCount?: number;
}

export const EmailDirectionFilter: React.FC<EmailDirectionFilterProps> = ({
  currentDirection,
  onDirectionChange,
  incomingCount = 0,
  outgoingCount = 0,
  totalCount = 0
}) => {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-muted-foreground mr-2">Direction:</span>
      
      <Button
        variant={currentDirection === 'all' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onDirectionChange('all')}
        className="flex items-center gap-2"
      >
        <ArrowUpDown className="h-4 w-4" />
        All
        <Badge variant="secondary" className="ml-1">
          {totalCount}
        </Badge>
      </Button>

      <Button
        variant={currentDirection === 'incoming' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onDirectionChange('incoming')}
        className="flex items-center gap-2"
      >
        <Mail className="h-4 w-4" />
        Received
        <Badge variant="secondary" className="ml-1">
          {incomingCount}
        </Badge>
      </Button>

      <Button
        variant={currentDirection === 'outgoing' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onDirectionChange('outgoing')}
        className="flex items-center gap-2"
      >
        <Send className="h-4 w-4" />
        Sent
        <Badge variant="secondary" className="ml-1">
          {outgoingCount}
        </Badge>
      </Button>
    </div>
  );
};
